import store from "src/store"
import Dialog from "./dialog"
import InputComponent from "./input-component/input-component"
import Progress from "./progress"
import { useEffect, useState } from "react"
import { requestJSON } from "src/utils/request-module"
import { useStepIndex } from "./step-index-context"
import consts from "shared/consts"

function qs() {
  return require("qs").parse(location.search.slice(1))
}

export default function CompileDialogForReview({ requestClose, reviewId }) {
  var [mainFile, setMainFile] = useState("mainfile.sol")
  var [mainContract, setMainContract] = useState("")
  const [validFiles, set_validFiles] = useState(false)
  const [compilerVersion, setCompilerVersion] = useState(
    "v0.8.15+commit.e14f2714",
  )
  const [files, setFiles] = useState([])
  const [compilerSettings, set_compilerSettings] = useState({})
  const [selectedFilePath, setSelectedFilePath] = useState(
    files?.[0]?.path || "",
  )
  const [byteCode, set_byteCode] = useState(files?.[0]?.path || "")
  const [loading, set_loading] = useState(false)
  const [importPopoverAnchorEl, setImportPopoverAnchorEl] = useState(null)
  var stepIndex = useStepIndex()

  async function onX() {
    let reviewData = {}
    if (Object.keys(store.selectedReviewData).length) {
      reviewData = store.selectedReviewData
    } else {
      reviewData = store.allMyReviews.find((review) => review._id === reviewId)
    }

    let prevFiles = []
    if (reviewData["files"]) {
      for (let i = 0; i < reviewData["files"].length; i++) {
        prevFiles.push({
          content: reviewData["files"][i]["content"],
          path:
            reviewData["files"][i]["name"] || reviewData["files"][i]["path"],
        })
      }
    }
    if (
      prevFiles.length &&
      files &&
      JSON.stringify(files) === JSON.stringify(prevFiles)
    ) {
      requestClose()
    } else {
      let { abi, bytecode } = await store.getAbi({
        files,
        mainContract: mainContract,
        mainFile,
        compilerVersion,
        compilerSettings,
      })

      let url = "/review/save-simplifier-data/"
      let body = {
        reviewId,
        files,
        abi,
        bytecode,
        mainContractName: mainContract,
        mainFileName: mainFile,
        compilerVersion,
        compilerSettings,
      }

      await requestJSON("POST", url, body)

      if (store.steps.length) {
        store.removeResults(stepIndex)
        store.steps[stepIndex].abi = abi
        store.abiABiUseUsingIt(stepIndex)
      }

      await store.invalidateReviewData(reviewId)
      await store.updateMyReviewList()

      if (qs().review_id) {
        store.selectedReviewData = store.allMyReviews.find(
          (review) => review._id === qs().review_id,
        )
        store.updateStore()
      }
      requestClose()

      if (location.pathname.match(consts.SCR_APP_URLS.scAnalyzer)) {
        store.openReanalyzeConfirmationModal()
      }

      if (location.pathname.match(consts.SCR_APP_URLS.simulation)) {
        store.updateByte32List()
      }
    }
  }

  useEffect(() => {
    getSimplifierDataAndReviewDetails()
  }, [])

  const getSimplifierDataAndReviewDetails = async () => {
    set_loading(true)
    try {
      let simplifiedData = await requestJSON(
        "GET",
        "/review/my-review/" + reviewId,
      )

      if (simplifiedData.files) {
        simplifiedData.files.forEach((file) => {
          file.path = file.path || file.name
          delete file.name
        })
      }
      if (Object.entries(simplifiedData).length > 0) {
      }
      // setSimplifiedData(simplifiedData)
      setMainContract(simplifiedData.mainContractName)
      setMainFile(simplifiedData.mainFileName)
      setCompilerVersion(simplifiedData.compilerVersion)
      setFiles(simplifiedData?.files || [{ path: "main.sol", content: "" }])
      set_compilerSettings(simplifiedData?.compilerSettings || {})
      set_byteCode(simplifiedData?.bytecode)
      // setReviewData(response[1]);
    } catch (err) {
      console.log(
        "Some error has occured while fetching completed simplifier data and review data ",
        err,
      )
    }
    set_loading(false)
  }

  const pageClickHandler = (e) => {
    if (!importPopoverAnchorEl) {
      return
    }
    const isClickOnToggleButtons = Boolean(
      e?.target?.closest("[id*='inputSelectionButton'"),
    )
    if (!isClickOnToggleButtons) {
      setImportPopoverAnchorEl(null)
    }
  }

  if (loading) {
    // @ts-ignore
    return (
      <Dialog open={true}>
        <div
          css={`
            width: 100%;
          `}
        >
          <Progress time={5000} />
        </div>
      </Dialog>
    )
  }
  console.log({ compilerSettings })
  //@ts-ignore
  return (
    <Dialog open={true} onClick={pageClickHandler}>
      <InputComponent
        skipAutoUpdateVersion
        skipShowSelectInputMethod={false}
        compilerVersion={compilerVersion}
        setCompilerVersion={setCompilerVersion}
        compilerSettings={compilerSettings}
        setCompilerSettings={set_compilerSettings}
        isLoading={false}
        files={files}
        setFiles={setFiles}
        mainFile={mainFile}
        setMainFile={setMainFile}
        mainContract={mainContract}
        // @ts-ignore
        setMainContract={(x) => {
          //@ts-ignore
          if (x.title) x = x.title
          setMainContract(x)
        }}
        setSelectedFilePath={(path) => {
          set_validFiles(null)
          setSelectedFilePath(path)
          store.updateStore()
        }}
        selectedFilePath={selectedFilePath}
        onX={onX}
        importPopoverAnchorEl={importPopoverAnchorEl}
        setImportPopoverAnchorEl={setImportPopoverAnchorEl}
      />
    </Dialog>
  )
}
